import { render } from "./MainPage.vue?vue&type=template&id=662d92da&ts=true"
import script from "./MainPage.vue?vue&type=script&lang=ts"
export * from "./MainPage.vue?vue&type=script&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=662d92da&lang=scss"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__